import React from "react";
import NavBar from "../../components/navBar/NavBar";
import SignatureCanvas from "react-signature-canvas";
import "../../assets/style/style.css";
import axios from "axios";
import swal from "sweetalert";
import ReactFileReader from "react-file-reader";
//import ptBr from "moment/locale/pt-br";
import moment from "moment";
import MaskedInput from "react-text-mask";

import Submit from "../../components/submit/Submit";
import ImgCard from "../../components/imgCard/ImgCard.jsx";
import "react-dates/initialize";

import { SingleDatePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import srcImgTomada1 from "../../img/tomada-1.jpg";
import srcImgTomada2 from "../../img/tomada-2.jpg";
import io from "socket.io-client";

//import './App.css';

require("dotenv").config();
const urlSocket = process.env.REACT_APP_API_SOCKET;
const url = process.env.REACT_APP_API_TASK;

const socket = io(urlSocket);

class ActivityClient extends React.Component {
  constructor(props) {
    super(props);
    this.HandleClickRadioService = this.HandleClickRadioService.bind(this);

    this.state = {
      data_chegada: "",
      pendencia: "",
      idViabilidade: "",
      empresa: "",
      endereco: "",
      bairro: "",
      complemento: "",
      email: "",
      telefone: "",
      telefone_fixo: "",
      tipo_servico: "",
      diagnostico: "",
      diagnosticoOutro: "",
      solucao: "",
      solucaoOutro: "",
      load: "false",
      imgDirecaoRepetidora: [],
      imgDirecaoRepetidoraText: [],
      imgTopoLocal: [],
      imgTopoLocalText: [],
      imgFixacaoAntena: [],
      imgFixacaoAntenaText: [],
      imgPercursoCabeamento: [],
      imgPercursoCabeamentoText: [],
      imgEntregaLink: [],
      imgEntregaLinkText: [],
      imgAntenaFixada: [],
      imgAntenaFixadaText: [],
      imgDirecaoEnlace: [],
      imgDirecaoEnlaceText: [],
      imgCabeamento: [],
      imgCabeamentoText: [],
      imgRbPoe: [],
      imgRbPoeText: [],
      imgTesteLink: [],
      imgTesteLinkText: [],
      imgAntenaRemovida: [],
      imgAntenaRemovidaText: [],
      imgEquipamentoAtuado: [],
      imgEquipamentoAtuadoText: [],
      tipo_suporte_outro: "",
      descricao: "",
      estacionamento: "",
      tensao: "",
      estimativa_cabo_metros: "",
      rg: "",
      showAssinatura: "Desabilitar Assinatura",
      assinatura: "",
      status_assinatura: ""
    };
  }
  componentDidMount() {
    const tokenLocal = localStorage.getItem("token");
    this.getActivityClient(this.props.match.params.id, tokenLocal);

    setTimeout(
      () => this.setState({ showAssinatura: "Habilitar Assinatura" }),
      300
    );
    window.addEventListener("orientationchange", this.orintation);
  }

  orintation = () => {
    this.postForm();
    if (window.matchMedia("(orientation: portrait)").matches) {
      console.log("portrait");
      this.setState({
        orientation: "portrait"
      });
    }
    if (window.matchMedia("(orientation: landscape)").matches) {
      // you're in LANDSCAPE mode
      console.log("landscape");
      this.setState({
        orientation: "landscape"
      });
    }
  };

  semAssinatura = () => {
    this.setState({
      status_assinatura: "nao_possui"
    });
  };

  startTask = () => {
    console.log("starta");
    const token = localStorage.getItem("token");
    const objForm = { id_rat_pop: this.props.match.params.id, token: token };

    axios
      .post(
        `${url}/inicioTask`,
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        socket.emit("newTask", "andamentoDash");
        this.setState({
          status: "andamento"
        });
      });
  };

  pauseTask = () => {
    console.log("pausar");
    const token = localStorage.getItem("token");
    const objForm = { id_rat_pop: this.props.match.params.id, token: token };
    axios
      .post(
        `${url}/pauseTask`,
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        socket.emit("newTask", "pauseDash");
        this.setState({
          status: "pause"
        });
      });
  };

  getActivityClient = (id, token) => {
    const objForm = { id: id, token: token };
    axios
      .post(
        `${url}/atividade_cliente`,
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        if (response.data.rat_client["0"].data_chegada) {
          this.setState({
            date: moment(response.data.rat_client["0"].data_chegada)
          });
        }

        this.setState({
          motivo_servico_interrompido:
            response.data.rat_client["0"].motivo_servico_interrompido,
          servico_interrompido:
            response.data.rat_client["0"].servico_interrompido,
          idViabilidade: response.data.rat_client["0"].id_viabilidade,
          empresa: response.data.viabilidade[0].empresa,
          endereco: response.data.viabilidade[0].endereco,
          bairro: response.data.viabilidade[0].bairro,
          complemento: response.data.viabilidade[0].complemento,
          telefone: response.data.viabilidade[0].telefone,
          numero: response.data.viabilidade[0].numero,
          email: response.data.viabilidade[0].contato_questionario_email,
          //date: moment(response.data.rat_client["0"].data_chegada),
          hora_chegada: response.data.rat_client["0"].hora_chegada,
          hora_liberacao: response.data.rat_client["0"].hora_liberacao,
          hora_saida: response.data.rat_client["0"].hora_saida,
          descricao: response.data.rat_client["0"].descricao,
          tipo_servico: response.data.rat_client["0"].tipo_servico,
          escada: response.data.rat_client["0"].escada,
          tipo_escada: response.data.rat_client["0"].tipo_escada,
          observacao: response.data.rat_client["0"].observacao,
          estacionamento: response.data.rat_client["0"].estacionamento,
          tensao: response.data.rat_client["0"].tensao,
          tomada: response.data.rat_client["0"].tomada,
          acessoCobertura: response.data.rat_client["0"].acesso_cobertura,
          tipo_suporte: response.data.rat_client["0"].tipo_suporte,
          tipo_suporte_outro: response.data.rat_client["0"].tipo_suporte_outro,
          estimativa_cabo_metros:
            response.data.rat_client["0"].estimativa_cabo_metros,
          imgDirecaoRepetidora: response.data.fotosDirecaoRepetidora,
          imgDirecaoRepetidoraText: response.data.fotosDirecaoRepetidora,
          imgTopoLocal: response.data.fotosTopoLocal,
          imgTopoLocalText: response.data.fotosTopoLocal,
          imgFixacaoAntena: response.data.fotosFixacaoAntena,
          imgFixacaoAntenaText: response.data.fotosFixacaoAntena,
          imgPercursoCabeamento: response.data.fotosPercursoCabeamento,
          imgPercursoCabeamentoText: response.data.fotosPercursoCabeamento,
          imgEntregaLink: response.data.fotosEntregaLink,
          imgEntregaLinkText: response.data.fotosEntregaLink,
          observacao_adicionais:
            response.data.rat_client["0"].observacao_adicionais,
          imgAntenaFixada: response.data.fotosAntenaFixada,
          imgAntenaFixadaText: response.data.fotosAntenaFixada,
          imgDirecaoEnlace: response.data.fotosDirecaoEnlace,
          imgDirecaoEnlaceText: response.data.fotosDirecaoEnlace,
          imgCabeamento: response.data.fotosCabeamento,
          imgCabeamentoText: response.data.fotosCabeamento,
          imgRbPoe: response.data.fotosRbPoe,
          imgRbPoeText: response.data.fotosRbPoe,
          imgTesteLink: response.data.fotosTesteLink,
          imgTesteLinkText: response.data.fotosTesteLink,
          imgAntenaRemovida: response.data.fotosAntenaRemovida,
          imgAntenaRemovidaText: response.data.fotosAntenaRemovida,
          imgEquipamentoAtuado: response.data.fotosAntenaEquipamentoAtuado,
          imgEquipamentoAtuadoText: response.data.fotosAntenaEquipamentoAtuado,
          instalacaoConcluida:
            response.data.rat_client["0"].instalacao_concluida,
          retiradaPendente: response.data.rat_client["0"].retirada_pendente,
          descricaoProblema: response.data.rat_client["0"].descricao_problema,
          solucao: response.data.rat_client["0"].solucao,
          solucaoOutro: response.data.rat_client["0"].solucao_outro,
          diagnostico: response.data.rat_client["0"].diagnostico,
          diagnosticoOutro: response.data.rat_client["0"].diagnostico_outro,
          velocidade: response.data.rat_client["0"].velocidade,
          responsavel: response.data.rat_client["0"].responsavel,
          assinatura: response.data.rat_client["0"].assinatura,
          status_assinatura: response.data.rat_client["0"].status_assinatura,
          tecnico: response.data.rat_client["0"].tecnico,
          status: response.data.rat_client["0"].status
        });

        if (response.data.viabilidade[0].email) {
          this.setState({
            email: response.data.viabilidade[0].email
          });
        }

        if (this.state.velocidade > 1000) {
          let velocidade = this.state.velocidade / 1024;
          this.setState({
            velocidade: velocidade,
            formatVelocidade: "Gbps"
          });
        } else {
          this.setState({
            formatVelocidade: "Mbps"
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  HabilitarDesabilitarAssin = e => {
    if (e === "Habilitar Assinatura") {
      this.setState({
        showAssinatura: "Desabilitar Assinatura"
      });
    } else {
      this.setState({
        showAssinatura: "Habilitar Assinatura"
      });
    }
  };

  deleteImg = (key, input, bd) => {
    //let inputText = input + "Text";

    let array = this.state[input];

    if (bd !== true) {
      array[key] = "";

      console.log(array);
      this.setState({ [input]: "" });
      this.setState({ [input]: array });
    } else {
      swal({
        title: "Você tem Certeza ?",
        text: " Está imagem será deletada!",
        icon: "warning",
        dangerMode: true,
        buttons: ["Cancelar", true]
      }).then(willDelete => {
        if (willDelete) {
          if (array[key].foto) {
            const objForm = {
              foto: array[key],
              token: localStorage.getItem("token")
            };
            axios
              .post(
                url + "/rat_pop_delete_foto",
                {
                  objForm: objForm
                  //nome : 'bruno'
                },
                {
                  headers: {
                    "Content-Type": "application/json;charset=UTF-8"
                  }
                }
              )
              .then(response => {
                if (response.data === 1) {
                  this.setState({ load: false });
                  swal("Deletado!", "Imagem Deletada!", "success");
                  array[key] = "";
                  this.setState({ [input]: array });
                } else {
                  swal("Falha!", "Não foi possivel excluir a imagem!", "error");
                }
              })
              .catch(function(error) {
                console.log(error);
              });
          }
        } else {
          this.setState({ [input]: "" });
          this.setState({ [input]: array });
        }
      });
    }
  };

  clearAssin = () => {
    swal({
      title: "Você tem certeza ?",
      text: "Está assinatura será limpada",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.sigCanvas.clear();
        this.setState({ status_assinatura: "" });
      }
    });
  };

  deletarAssinatura = () => {
    const objForm = {
      id: this.props.match.params.id,
      token: localStorage.getItem("token")
    };
    axios
      .post(
        url + "/postRatClientClearSignature",
        {
          objForm: objForm
          //nome : 'bruno'
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        if (response.data === 1) {
          swal("Deletado!", "Assinatura deletada!", "success").then(value => {
            window.location.reload();
          });

          /*
          swal("Click on either the button or outside the modal.")
          .then((value) => {
            swal(`The returned value is: ${value}`);
          });

      */
        } else {
          swal("Falha!", "Não foi possivel excluir a assinatura!", "error");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  postForm = () => {
    this.setState({ load: true });
    let assinaturaAux;
    if (this.state.assinatura) {
      assinaturaAux = this.state.assinatura;
    } else {
      if (!this.sigCanvas.isEmpty()) {
        assinaturaAux = this.sigCanvas.toDataURL();
      } else {
        assinaturaAux = "";
      }
    }
    let objForm = {
      token: localStorage.getItem("token"),
      servico_interrompido: this.state.servico_interrompido,
      motivo_servico_interrompido: this.state.motivo_servico_interrompido,
      id: this.props.match.params.id,

      empresa: this.state.empresa,
      email: this.state.email,
      //data_chegada: moment(this.state.date).format("L"),
      endereco: this.state.endereco,
      complemento: this.state.complemento,
      bairro: this.state.bairro,
      telefone: this.state.telefone,
      data_chegada: moment(this.state.date).format("YYYY-MM-DD"),
      hora_chegada: this.state.hora_chegada,
      hora_liberacao: this.state.hora_liberacao,
      hora_saida: this.state.hora_saida,
      descricao: this.state.descricao,
      tipo_servico: this.state.tipo_servico,
      escada: this.state.escada,
      tipo_escada: this.state.tipo_escada,
      observacao: this.state.observacao,
      estacionamento: this.state.estacionamento,
      tensao: this.state.tensao,
      tomada: this.state.tomada,
      acessoCobertura: this.state.acessoCobertura,
      observacao_adicionais: this.state.observacao_adicionais,
      imgDirecaoRepetidora: this.state.imgDirecaoRepetidora,
      imgDirecaoRepetidoraText: this.state.imgDirecaoRepetidoraText,
      imgTopoLocal: this.state.imgTopoLocal,
      imgTopoLocalText: this.state.imgTopoLocalText,
      imgFixacaoAntena: this.state.imgFixacaoAntena,
      imgFixacaoAntenaText: this.state.imgFixacaoAntenaText,
      tipo_suporte: this.state.tipo_suporte,
      tipo_suporte_outro: this.state.tipo_suporte_outro,
      imgPercursoCabeamento: this.state.imgPercursoCabeamento,
      imgPercursoCabeamentoText: this.state.imgPercursoCabeamentoText,
      estimativa_cabo_metros: this.state.estimativa_cabo_metros,
      imgEntregaLink: this.state.imgEntregaLink,
      imgEntregaLinkText: this.state.imgEntregaLinkText,
      instalacaoConcluida: this.state.instalacaoConcluida,
      imgAntenaFixada: this.state.imgAntenaFixada,
      imgAntenaFixadaText: this.state.imgAntenaFixadaText,
      imgDirecaoEnlace: this.state.imgDirecaoEnlace,
      imgDirecaoEnlaceText: this.state.imgDirecaoEnlaceText,
      imgCabeamento: this.state.imgCabeamento,
      imgCabeamentoText: this.state.imgCabeamentoText,
      imgRbPoe: this.state.imgRbPoe,
      imgRbPoeText: this.state.imgRbPoeText,
      imgTesteLink: this.state.imgTesteLink,
      imgTesteLinkText: this.state.imgTesteLinkText,
      retiradaPendente: this.state.retiradaPendente,
      imgAntenaRemovida: this.state.imgAntenaRemovida,
      imgAntenaRemovidaText: this.state.imgAntenaRemovidaText,
      descricaoProblema: this.state.descricaoProblema,
      diagnostico: this.state.diagnostico,
      diagnosticoOutro: this.state.diagnosticoOutro,
      solucao: this.state.solucao,
      solucaoOutro: this.state.solucaoOutro,
      imgEquipamentoAtuado: this.state.imgEquipamentoAtuado,
      imgEquipamentoAtuadoText: this.state.imgEquipamentoAtuadoText,
      assinatura: assinaturaAux,
      status_assinatura: this.state.status_assinatura,
      responsavel: this.state.responsavel,
      tecnico: this.state.tecnico
    };

    if (socket.connected) {
      axios
        .post(
          url + "/rat_cliente",
          {
            objForm: objForm
            //nome : 'bruno'
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8"
            }
          }
        )
        .then(response => {
          if (response.data === 1) {
            this.setState({ load: false });

            swal({
              title: "Salvo",
              text: "Dados enviados!",
              icon: "success"
            }).then(willDelete => {
              if (willDelete) {
                socket.emit("newTask", "pauseDash");
                window.location.reload();
              }
            });
          } else {
            swal("Não Salvo", " Ocorreu erro ao Salvar ", "error");
            //this.setState({load:false});
          }
        })
        .catch(function(error) {
          console.log(error);
          swal({
            title: "Falha!",
            text: "Não foi possivel salvar os dados",
            icon: "error"
          }).then(willDelete => {
            if (willDelete) {
              window.location.reload();
            }
          });
        });
      /*
      axios
        .post(
          url + "/postSendEmailRatCliente",
          {
            objForm: objForm
            //nome : 'bruno'
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8"
            }
          }
        )
        .then(response => {
          console.log(response);
        })
        .catch(function(error) {
          console.log(error);
        });
        */
    } else {
      let arrayLocal = [];
      if (localStorage.getItem("dadosClient")) {
        arrayLocal = JSON.parse(localStorage.getItem("dadosClient"));
        arrayLocal.push(objForm);
      } else {
        arrayLocal.push(objForm);
      }
      arrayLocal = JSON.stringify(arrayLocal);
      localStorage.setItem("dadosClient", arrayLocal);

      swal({
        title: "Salvo",
        text: "Dados Salvos no aparelho, sem conectividade com a internet!",
        icon: "success"
      }).then(willDelete => {
        if (willDelete) {
          window.location.reload();
        }
      });
    }
  };

  handleFilesDirecaoRepetidora = files => {
    
    files.base64.map(file => {
      this.setState({
        imgDirecaoRepetidora: [...this.state.imgDirecaoRepetidora, file]
      });
      return true;
    });
    
  };

  handleFilesTopoLocal = files => {
    files.base64.map(file => {
      this.setState({
        imgTopoLocal: [...this.state.imgTopoLocal, file]
      });
      return true;
    });
  };

  handleFilesFixacaoAntena = files => {
    files.base64.map(file => {
      this.setState({
        imgFixacaoAntena: [...this.state.imgFixacaoAntena, file]
      });
      return true;
    });
  };

  handleFilesPercursoCabeamento = files => {
    files.base64.map(file => {
      this.setState({
        imgPercursoCabeamento: [...this.state.imgPercursoCabeamento, file]
      });
      return true;
    });
  };

  handleFilesEntregaLink = files => {
    files.base64.map(file => {
      this.setState({
        imgEntregaLink: [...this.state.imgEntregaLink, file]
      });
      return true;
    });
  };

  handleFilesAntenaFixada = files => {
    files.base64.map(file => {
      this.setState({
        imgAntenaFixada: [...this.state.imgAntenaFixada, file]
      });
      return true;
    });
  };

  handleFilesDirecaoEnlace = files => {
    files.base64.map(file => {
      this.setState({
        imgDirecaoEnlace: [...this.state.imgDirecaoEnlace, file]
      });
      return true;
    });
  };

  handleFilesCabeamento = files => {
    files.base64.map(file => {
      this.setState({
        imgCabeamento: [...this.state.imgCabeamento, file]
      });
      return true;
    });
  };

  handleFilesRbPoe = files => {
    files.base64.map(file => {
      this.setState({
        imgRbPoe: [...this.state.imgRbPoe, file]
      });
      return true;
    });
  };

  handleFilesTesteLink = files => {
    files.base64.map(file => {
      this.setState({
        imgTesteLink: [...this.state.imgTesteLink, file]
      });
      return true;
    });
  };

  handleFilesAntenaRemovida = files => {
    files.base64.map(file => {
      this.setState({
        imgAntenaRemovida: [...this.state.imgAntenaRemovida, file]
      });
      return true;
    });
  };

  handleFilesEquipamentoAtuado = files => {
    files.base64.map(file => {
      this.setState({
        imgEquipamentoAtuado: [...this.state.imgEquipamentoAtuado, file]
      });
      return true;
    });
  };

  handleInputChangeHora = e => {
    const key = e.target.id;
    this.setState({ [key]: e.target.value });
  };

  HandleClickRadioService(event) {
    this.setState({ tipo_servico: event.target.value });
    //console.log(this.state.tipo_servico);
  }

  handleClickRadio = event => {
    let key = event.target.name;
    let value = event.target.value;

    if (key === "diagnostico" && value !== "outro") {
      this.setState({ diagnosticoOutro: "" });
    }

    if (key === "solucao" && value !== "outro") {
      this.setState({ solucaoOutro: "" });
    }

    if (key === "tipo_suporte" && value !== "outro") {
      this.setState({ tipo_suporte_outro: "" });
    }

    if (key === "escada" && value !== "nao") {
      this.setState({ tipo_escada: "" });
    }

    this.setState({ [key]: value });
  };

  handleInputChange = event => {
    const key = event.target.name;
    const value = event.target.value;
    this.setState({ [key]: value });
  };

  handleInputChangeText = e => {
    let typeIMG = e.target.name;
    let indice = e.target.id;
    let value = e.target.value;
    if (this.state[typeIMG]) {
      let array = this.state[typeIMG];
      array[indice] = { ...array[indice], descricao: value };
      this.setState({ [typeIMG]: array });
    } else {
      let array = [];
      array[indice] = { descricao: value };
      this.setState({ [typeIMG]: array });
    }
  };

  tipo_servico() {
    if (this.state.tipo_servico === "vistoria") {
      return (
        <React.Fragment>
          <div className="form-group">
            <label htmlFor="estacionamento">
              <i className="fas fa-exclamation-triangle" />

              {!this.state.estacionamento ? (
                <span className="text-danger"> Estacionamento ? * </span>
              ) : (
                <React.Fragment>Estacionamento ?</React.Fragment>
              )}
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="estacionamento"
                id="estacionamento1"
                value="sim"
                onChange={this.handleClickRadio.bind(this)}
                checked={this.state.estacionamento === "sim"}
              />
              <label className="form-check-label" htmlFor="estacionamento1">
                Sim
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="estacionamento"
                id="estacionamento2"
                value="nao"
                onChange={this.handleClickRadio.bind(this)}
                checked={this.state.estacionamento === "nao"}
              />
              <label className="form-check-label" htmlFor="estacionamento2">
                Não
              </label>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="tensao">
              <i className="fas fa-exclamation-triangle" />
              {!this.state.tensao ? (
                <span className="text-danger"> Tensão Elétrica ? * </span>
              ) : (
                <React.Fragment>Tensão Elétrica ?</React.Fragment>
              )}
            </label>

            <div className="form-check">
              <input
                //defaultChecked
                className="form-check-input"
                type="radio"
                name="tensao"
                id="tensao1"
                value="127"
                onChange={this.handleClickRadio.bind(this)}
                checked={this.state.tensao === "127"}
              />
              <label className="form-check-label" htmlFor="tensao1">
                127 V
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="tensao"
                id="tensao2"
                value="220"
                onChange={this.handleClickRadio.bind(this)}
                checked={this.state.tensao === "220"}
              />
              <label className="form-check-label" htmlFor="tensao2">
                220 V
              </label>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="tomada">
              <i className="fas fa-exclamation-triangle" />
              {!this.state.tomada ? (
                <span className="text-danger">Padrão de Tomada local ? *</span>
              ) : (
                <React.Fragment>Padrão de Tomada local ?</React.Fragment>
              )}
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="tomada"
                id="tomada1"
                value="tomada1"
                onChange={this.handleClickRadio.bind(this)}
                checked={this.state.tomada === "tomada1"}
              />
              <label className="form-check-label" htmlFor="tomada1">
                Tomada 1 -
                <img src={srcImgTomada1} alt="tomada 1" />
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="tomada"
                id="tomada2"
                value="tomada2"
                onChange={this.handleClickRadio.bind(this)}
                checked={this.state.tomada === "tomada2"}
              />
              <label className="form-check-label" htmlFor="tomada2">
                Tomada 2 - <img src={srcImgTomada2} alt="tomada 2" />
              </label>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="formasAcesso">
              <i className="fas fa-exclamation-triangle" />
              {!this.state.acessoCobertura ? (
                <span className="text-danger">
                  Formas de acesso à cobertura do local ?*
                </span>
              ) : (
                <React.Fragment>
                  Formas de acesso à cobertura do local ?
                </React.Fragment>
              )}
            </label>
            <textarea
              className="form-control"
              id="formasAcesso"
              rows="3"
              onChange={this.handleInputChange.bind(this)}
              name="acessoCobertura"
              value={this.state.acessoCobertura}
            />
          </div>
          <div className="form-group">
            <label>
              <i className="fas fa-exclamation-triangle" />
              {!this.state.imgDirecaoRepetidora.length > 0 ? (
                <span className="text-danger">
                  Foto da direção da repetidora *
                </span>
              ) : (
                <React.Fragment>Foto da direção da repetidora</React.Fragment>
              )}
            </label>
            <div className="form-group">
              <ReactFileReader
                handleFiles={this.handleFilesDirecaoRepetidora}
                base64={true}
                multipleFiles={true}
                ref="fotosNecessaria"
                name="fotosNecessaria"
              >
                <button className="btn btn-primary marginRight4">Foto</button>
              </ReactFileReader>
            </div>
            <div className="form-group containerImg">
              {this.state.imgDirecaoRepetidora &&
                this.state.imgDirecaoRepetidora.map((img, i) =>
                  img.foto ? (
                    <div key={i}>
                      <ImgCard
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgDirecaoRepetidora", true)
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgDirecaoRepetidoraText"
                        idName={i}
                      />
                    </div>
                  ) : (
                    <div key={i}>
                      <ImgCard
                        src={img}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgDirecaoRepetidora")
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgDirecaoRepetidoraText"
                        idName={i}
                      />
                    </div>
                  )
                )}
            </div>
          </div>
          <div className="form-group">
            <label>
              <i className="fas fa-exclamation-triangle" />
              {!this.state.imgTopoLocal.length > 0 ? (
                <span className="text-danger">Foto 360 no topo do local *</span>
              ) : (
                <React.Fragment>Foto 360 no topo do local</React.Fragment>
              )}
            </label>
            <div className="form-group">
              <ReactFileReader
                handleFiles={this.handleFilesTopoLocal}
                base64={true}
                multipleFiles={true}
                ref="fotosNecessaria"
                name="fotosNecessaria"
              >
                <button className="btn btn-primary marginRight4">Foto</button>
              </ReactFileReader>
            </div>
            <div className="form-group containerImg">
              {this.state.imgTopoLocal &&
                this.state.imgTopoLocal.map((img, i) =>
                  img.foto ? (
                    <div key={i}>
                      <ImgCard
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgTopoLocal", true)
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgTopoLocalText"
                        idName={i}
                      />
                    </div>
                  ) : (
                    <div key={i}>
                      <ImgCard
                        src={img}
                        clickDeleteImg={() => this.deleteImg(i, "imgTopoLocal")}
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgTopoLocalText"
                        idName={i}
                      />
                    </div>
                  )
                )}
            </div>
          </div>
          <div className="form-group">
            <label>
              <i className="fas fa-exclamation-triangle" />
              {!this.state.imgFixacaoAntena.length > 0 ? (
                <span className="text-danger">Foto local fixação antena *</span>
              ) : (
                <React.Fragment>Foto local fixação antena</React.Fragment>
              )}
            </label>
            <div className="form-group">
              <ReactFileReader
                handleFiles={this.handleFilesFixacaoAntena}
                base64={true}
                multipleFiles={true}
                ref="fotosNecessaria"
                name="fotosNecessaria"
              >
                <button className="btn btn-primary marginRight4">Foto</button>
              </ReactFileReader>
            </div>
            <div className="form-group containerImg">
              {this.state.imgFixacaoAntena &&
                this.state.imgFixacaoAntena.map((img, i) =>
                  img.foto ? (
                    <div key={i}>
                      <ImgCard
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgFixacaoAntena", true)
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgFixacaoAntenaText"
                        idName={i}
                      />
                    </div>
                  ) : (
                    <div key={i}>
                      <ImgCard
                        src={img}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgFixacaoAntena")
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgFixacaoAntenaText"
                        idName={i}
                      />
                    </div>
                  )
                )}
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="tipoSuporte">
              <i className="fas fa-exclamation-triangle" />
              {!this.state.tipo_suporte.length > 0 ? (
                <span className="text-danger"> Tipo de Suporte ? * </span>
              ) : (
                <React.Fragment>Tipo de Suporte ?</React.Fragment>
              )}
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="tipo_suporte"
                id="tipo_suporte1"
                value="tripe"
                onChange={this.handleClickRadio.bind(this)}
                checked={this.state.tipo_suporte === "tripe"}
              />
              <label className="form-check-label" htmlFor="tipo_suporte1">
                Tripé
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="tipo_suporte"
                id="tipo_suporte2"
                value="parede"
                onChange={this.handleClickRadio.bind(this)}
                checked={this.state.tipo_suporte === "parede"}
              />
              <label className="form-check-label" htmlFor="tipo_suporte2">
                Parede
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="tipo_suporte"
                id="tipo_suporte3"
                value="outro"
                onChange={this.handleClickRadio.bind(this)}
                checked={this.state.tipo_suporte === "outro"}
              />
              <label
                className="form-check-label"
                htmlFor="tipo_suporte3"
                onChange={this.handleClickRadio.bind(this)}
              >
                Outros{" "}
                {!this.state.tipo_suporte_outro.length > 0 &&
                  this.state.tipo_suporte === "outro" && (
                    <span className="text-danger"> * </span>
                  )}
              </label>
            </div>
            {this.state.tipo_suporte === "outro" && (
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  id="inputAddress2"
                  name="tipo_suporte_outro"
                  onChange={this.handleInputChange.bind(this)}
                  value={this.state.tipo_suporte_outro}
                />
              </div>
            )}
          </div>
          <div className="form-group">
            <label>
              <i className="fas fa-exclamation-triangle" />
              {!this.state.imgPercursoCabeamento.length > 0 ? (
                <span className="text-danger">
                  {" "}
                  Foto de percurso do cabeamento *{" "}
                </span>
              ) : (
                <React.Fragment>Foto de percurso do cabeamento</React.Fragment>
              )}
            </label>
            <div className="form-group">
              <ReactFileReader
                handleFiles={this.handleFilesPercursoCabeamento}
                base64={true}
                multipleFiles={true}
                ref="fotosNecessaria"
                name="fotosNecessaria"
              >
                <button className="btn btn-primary marginRight4">Foto</button>
              </ReactFileReader>
            </div>
            <div className="form-group containerImg">
              {this.state.imgPercursoCabeamento &&
                this.state.imgPercursoCabeamento.map((img, i) =>
                  img.foto ? (
                    <div key={i}>
                      <ImgCard
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgPercursoCabeamento", true)
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgPercursoCabeamentoText"
                        idName={i}
                      />
                    </div>
                  ) : (
                    <div key={i}>
                      <ImgCard
                        src={img}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgPercursoCabeamento")
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgPercursoCabeamentoText"
                        idName={i}
                      />
                    </div>
                  )
                )}
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="estimativaCabo">
              <i className="fas fa-exclamation-triangle" />
              {!this.state.estimativa_cabo_metros ? (
                <span className="text-danger">
                  Estimativa do cabo em metros:*
                </span>
              ) : (
                <React.Fragment>Estimativa do cabo em metros:</React.Fragment>
              )}
            </label>
            <input
              type="text"
              className="form-control"
              id="estimativaCabo"
              onChange={this.handleInputChange.bind(this)}
              name="estimativa_cabo_metros"
              defaultValue={this.state.estimativa_cabo_metros}
            />
          </div>
          <div className="form-group">
            <label>
              <i className="fas fa-exclamation-triangle" />
              {!this.state.imgEntregaLink.length > 0 ? (
                <span className="text-danger">Foto de entrega do link * </span>
              ) : (
                <React.Fragment>Foto de entrega do link</React.Fragment>
              )}
            </label>
            <div className="form-group">
              <ReactFileReader
                handleFiles={this.handleFilesEntregaLink}
                base64={true}
                multipleFiles={true}
                ref="fotosNecessaria"
                name="fotosNecessaria"
              >
                <button className="btn btn-primary marginRight4">Foto</button>
              </ReactFileReader>
            </div>
            <div className="form-group containerImg">
              {this.state.imgEntregaLink &&
                this.state.imgEntregaLink.map((img, i) =>
                  img.foto ? (
                    <div key={i}>
                      <ImgCard
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgEntregaLink", true)
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgEntregaLinkText"
                        idName={i}
                      />
                    </div>
                  ) : (
                    <div key={i}>
                      <ImgCard
                        src={img}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgEntregaLink")
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgEntregaLinkText"
                        idName={i}
                      />
                    </div>
                  )
                )}
            </div>
          </div>
        </React.Fragment>
      );
    } else if (this.state.tipo_servico === "instalacao") {
      return (
        <React.Fragment>
          <div className="form-group">
            <label>
              <i className="fas fa-exclamation-triangle" />
              {!this.state.instalacaoConcluida ? (
                <span className="text-danger">
                  Instalação concluída e funcionamento perfeito ? *
                </span>
              ) : (
                <React.Fragment>
                  Instalação concluída e funcionamento perfeito ?
                </React.Fragment>
              )}
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="instalacaoConcluida"
                id="instalacaoConcluida1"
                value="sim"
                onClick={this.handleClickRadio.bind(this)}
                defaultChecked={this.state.instalacaoConcluida === "sim" || ""}
              />
              <label
                className="form-check-label"
                htmlFor="instalacaoConcluida1"
              >
                Sim
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="instalacaoConcluida"
                id="instalacaoConcluida2"
                value="nao"
                onClick={this.handleClickRadio.bind(this)}
                defaultChecked={this.state.instalacaoConcluida === "nao" || ""}
              />
              <label
                className="form-check-label"
                htmlFor="instalacaoConcluida2"
              >
                Não
              </label>
            </div>
          </div>
          <div className="form-group">
            <label>
              <i className="fas fa-exclamation-triangle" />
              {!this.state.imgAntenaFixada.length > 0 ? (
                <span className="text-danger"> Foto antena fixada * </span>
              ) : (
                <React.Fragment>Foto antena fixada</React.Fragment>
              )}
            </label>
            <div className="form-group">
              <ReactFileReader
                handleFiles={this.handleFilesAntenaFixada}
                base64={true}
                multipleFiles={true}
                ref="fotosNecessaria"
                name="fotosNecessaria"
              >
                <button className="btn btn-primary marginRight4">Foto</button>
              </ReactFileReader>
            </div>
            <div className="form-group containerImg">
              {this.state.imgAntenaFixada &&
                this.state.imgAntenaFixada.map((img, i) =>
                  img.foto ? (
                    <div key={i}>
                      <ImgCard
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgAntenaFixada", true)
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgAntenaFixadaText"
                        idName={i}
                      />
                    </div>
                  ) : (
                    <div key={i}>
                      <ImgCard
                        src={img}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgAntenaFixada")
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgAntenaFixadaText"
                        idName={i}
                      />
                    </div>
                  )
                )}
            </div>
          </div>
          <div className="form-group">
            <label>
              <i className="fas fa-exclamation-triangle" />
              {!this.state.imgDirecaoEnlace.length > 0 ? (
                <span className="text-danger"> Foto direção enlace * </span>
              ) : (
                <React.Fragment>Foto direção enlace</React.Fragment>
              )}
            </label>
            <div className="form-group">
              <ReactFileReader
                handleFiles={this.handleFilesDirecaoEnlace}
                base64={true}
                multipleFiles={true}
                ref="fotosNecessaria"
                name="fotosNecessaria"
              >
                <button className="btn btn-primary marginRight4">Foto</button>
              </ReactFileReader>
            </div>
            <div className="form-group containerImg">
              {this.state.imgDirecaoEnlace &&
                this.state.imgDirecaoEnlace.map((img, i) =>
                  img.foto ? (
                    <div key={i}>
                      <ImgCard
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgDirecaoEnlace", true)
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgDirecaoEnlaceText"
                        idName={i}
                      />
                    </div>
                  ) : (
                    <div key={i}>
                      <ImgCard
                        src={img}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgDirecaoEnlace")
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgDirecaoEnlaceText"
                        idName={i}
                      />
                    </div>
                  )
                )}
            </div>
          </div>
          <div className="form-group">
            <label>
              <i className="fas fa-exclamation-triangle" />
              {!this.state.imgCabeamento.length > 0 ? (
                <span className="text-danger"> Foto cabeamento * </span>
              ) : (
                <React.Fragment>Foto cabeamento</React.Fragment>
              )}
            </label>
            <div className="form-group">
              <div className="form-group">
                <ReactFileReader
                  handleFiles={this.handleFilesCabeamento}
                  base64={true}
                  multipleFiles={true}
                  ref="fotosNecessaria"
                  name="fotosNecessaria"
                >
                  <button className="btn btn-primary marginRight4">Foto</button>
                </ReactFileReader>
              </div>
            </div>
            <div className="form-group containerImg">
              {this.state.imgCabeamento &&
                this.state.imgCabeamento.map((img, i) =>
                  img.foto ? (
                    <div key={i}>
                      <ImgCard
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgCabeamento", true)
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgCabeamentoText"
                        idName={i}
                      />
                    </div>
                  ) : (
                    <div key={i}>
                      <ImgCard
                        src={img}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgCabeamento")
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgCabeamentoText"
                        idName={i}
                      />
                    </div>
                  )
                )}
            </div>
          </div>
          <div className="form-group">
            <label>
              <i className="fas fa-exclamation-triangle" />
              {!this.state.imgRbPoe.length > 0 ? (
                <span className="text-danger">
                  Foto RB e POE identificado *{" "}
                </span>
              ) : (
                <React.Fragment>Foto RB e POE identificado</React.Fragment>
              )}
            </label>
            <div className="form-group">
              <div className="form-group">
                <ReactFileReader
                  handleFiles={this.handleFilesRbPoe}
                  base64={true}
                  multipleFiles={true}
                  ref="fotosNecessaria"
                  name="fotosNecessaria"
                >
                  <button className="btn btn-primary marginRight4">Foto</button>
                </ReactFileReader>
              </div>
            </div>
            <div className="form-group containerImg">
              {this.state.imgRbPoe &&
                this.state.imgRbPoe.map((img, i) =>
                  img.foto ? (
                    <div key={i}>
                      <ImgCard
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgRbPoe", true)
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgRbPoeText"
                        idName={i}
                      />
                    </div>
                  ) : (
                    <div key={i}>
                      <ImgCard
                        description="s/descricao"
                        src={img}
                        clickDeleteImg={() => this.deleteImg(i, "imgRbPoe")}
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgRbPoeText"
                        idName={i}
                      />
                    </div>
                  )
                )}
            </div>
          </div>
          <div className="form-group">
            <label>
              <i className="fas fa-exclamation-triangle" />
              {!this.state.imgTesteLink.length > 0 ? (
                <span className="text-danger">
                  Foto teste link quando aplicado *
                </span>
              ) : (
                <React.Fragment>Foto teste link quando aplicado</React.Fragment>
              )}
            </label>
            <div className="form-group">
              <ReactFileReader
                handleFiles={this.handleFilesTesteLink}
                base64={true}
                multipleFiles={true}
                ref="fotosNecessaria"
                name="fotosNecessaria"
              >
                <button className="btn btn-primary marginRight4">Foto</button>
              </ReactFileReader>
            </div>
            <div className="form-group containerImg">
              {this.state.imgTesteLink &&
                this.state.imgTesteLink.map((img, i) =>
                  img.foto ? (
                    <div key={i}>
                      <ImgCard
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgTesteLink", true)
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgTesteLinkText"
                        idName={i}
                      />
                    </div>
                  ) : (
                    <div key={i}>
                      <ImgCard
                        src={img}
                        clickDeleteImg={() => this.deleteImg(i, "imgTesteLink")}
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgTesteLinkText"
                        idName={i}
                        description=""
                      />
                    </div>
                  )
                )}
            </div>
          </div>
        </React.Fragment>
      );
    } else if (this.state.tipo_servico === "retirada") {
      return (
        <React.Fragment>
          <div className="form-group">
            <label>
              <i className="fas fa-exclamation-triangle" />
              {!this.state.retiradaPendente ? (
                <span className="text-danger">
                  Retirada concluída sem pendências ? *{" "}
                </span>
              ) : (
                <React.Fragment>
                  Retirada concluída sem pendências ?
                </React.Fragment>
              )}
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="retiradaPendente"
                id="retiradaPendente1"
                value="sim"
                onClick={this.handleClickRadio.bind(this)}
                checked={this.state.retiradaPendente === "sim" || ""}
              />
              <label className="form-check-label" htmlFor="retiradaPendente1">
                Sim
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="retiradaPendente"
                id="retiradaPendente2"
                value="nao"
                onClick={this.handleClickRadio.bind(this)}
                checked={this.state.retiradaPendente === "nao" || ""}
              />
              <label className="form-check-label" htmlFor="retiradaPendente2">
                Não
              </label>
            </div>
          </div>
          <div className="form-group">
            <label>
              {!this.state.imgAntenaRemovida.length > 0 ? (
                <span className="text-danger">
                  Foto local antena removida *
                </span>
              ) : (
                <React.Fragment>Foto local antena removida</React.Fragment>
              )}
            </label>
            <div className="form-group">
              <ReactFileReader
                handleFiles={this.handleFilesAntenaRemovida}
                base64={true}
                multipleFiles={true}
                ref="fotosNecessaria"
                name="fotosNecessaria"
              >
                <button className="btn btn-primary marginRight4">Foto</button>
              </ReactFileReader>
            </div>
            <div className="form-group containerImg">
              {this.state.imgAntenaRemovida &&
                this.state.imgAntenaRemovida.map((img, i) =>
                  img.foto ? (
                    <div key={i}>
                      <ImgCard
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgAntenaRemovida", true)
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgAntenaRemovidaText"
                        idName={i}
                      />
                    </div>
                  ) : (
                    <div key={i}>
                      <ImgCard
                        src={img}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgAntenaRemovida")
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgAntenaRemovidaText"
                        idName={i}
                      />
                    </div>
                  )
                )}
            </div>
          </div>
        </React.Fragment>
      );
    } else if (
      this.state.tipo_servico === "manutencao_preventiva" ||
      this.state.tipo_servico === "manutencao_corretiva" ||
      this.state.tipo_servico === "manutencao_emergencial"
    ) {
      return (
        <React.Fragment>
          <div className="form-group">
            <label htmlFor="exampleFormControlTextarea1">
              {!this.state.descricaoProblema ? (
                <span className="text-danger">
                  Descrição detalhada do problema *
                </span>
              ) : (
                <React.Fragment>Descrição detalhada do problema</React.Fragment>
              )}
            </label>
            <textarea
              onChange={this.handleInputChange.bind(this)}
              name="descricaoProblema"
              className="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
              value={this.state.descricaoProblema}
            />
          </div>
          <div className="form-group">
            <label htmlFor="exampleFormControlSelect1">
              <i className="fas fa-exclamation-triangle" />
              {!this.state.diagnostico ||
              (this.state.diagnostico === "outro" &&
                !this.state.diagnosticoOutro) ? (
                <span className="text-danger">Diagnóstico do Serviço ? * </span>
              ) : (
                <React.Fragment>Diagnóstico do Serviço ?</React.Fragment>
              )}
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="diagnostico"
                id="diagnostico1"
                value="cabo rompido"
                onClick={this.handleClickRadio.bind(this)}
                checked={this.state.diagnostico === "cabo rompido"}
              />
              <label className="form-check-label" htmlFor="diagnostico1">
                Cabo rompido
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="diagnostico"
                id="diagnostico2"
                value="poe defeituoso"
                onClick={this.handleClickRadio.bind(this)}
                checked={this.state.diagnostico === "poe defeituoso"}
              />
              <label className="form-check-label" htmlFor="diagnostico2">
                Poe defeituoso
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="diagnostico"
                id="diagnostico3"
                value="radio defeituoso"
                onClick={this.handleClickRadio.bind(this)}
                checked={this.state.diagnostico === "radio defeituoso"}
              />
              <label className="form-check-label" htmlFor="diagnostico3">
                Rádio defeituoso
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="diagnostico"
                id="diagnostico4"
                value="conector defeituoso"
                onClick={this.handleClickRadio.bind(this)}
                checked={this.state.diagnostico === "conector defeituoso"}
              />
              <label className="form-check-label" htmlFor="diagnostico4">
                Conector defeituoso
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="diagnostico"
                id="diagnostico5"
                value="rb defeituosa"
                onClick={this.handleClickRadio.bind(this)}
                checked={this.state.diagnostico === "rb defeituosa"}
              />
              <label className="form-check-label" htmlFor="diagnostico5">
                RB defeituosa
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="diagnostico"
                id="diagnostico6"
                value="problema elétrico"
                onClick={this.handleClickRadio.bind(this)}
                checked={this.state.diagnostico === "problema elétrico"}
              />
              <label className="form-check-label" htmlFor="diagnostico6">
                Problema elétrico
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="diagnostico"
                id="diagnostico7"
                value="antena defeituosa"
                onClick={this.handleClickRadio.bind(this)}
                checked={this.state.diagnostico === "antena defeituosa"}
              />
              <label className="form-check-label" htmlFor="diagnostico7">
                Antena defeituosa
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="diagnostico"
                id="diagnostico8"
                value="outro"
                onClick={this.handleClickRadio.bind(this)}
                checked={this.state.diagnostico === "outro"}
              />
              <label className="form-check-label" htmlFor="diagnostico8">
                {!this.state.diagnosticoOutro &&
                this.state.diagnostico === "outro" ? (
                  <span className="text-danger"> Outro * </span>
                ) : (
                  <React.Fragment>Outro</React.Fragment>
                )}
              </label>
            </div>

            {this.state.diagnostico === "outro" && (
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  id="inputAddress2"
                  name="diagnosticoOutro"
                  value={this.state.diagnosticoOutro}
                  onChange={this.handleInputChange.bind(this)}
                />
              </div>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="exampleFormControlSelect1">
              <i className="fas fa-exclamation-triangle" />
              {!this.state.solucao ||
              (this.state.solucao === "outro" && !this.state.solucaoOutro) ? (
                <span className="text-danger"> Solução ? * </span>
              ) : (
                <React.Fragment>Solução ?</React.Fragment>
              )}
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="solucao"
                id="solucao1"
                value="substituição do cabeamento todo"
                onClick={this.handleClickRadio.bind(this)}
                checked={
                  this.state.solucao === "substituição do cabeamento todo"
                }
              />
              <label className="form-check-label" htmlFor="solucao1">
                Substituição do cabeamento todo
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="solucao"
                id="solucao2"
                value="substituição do cabo porta poe"
                onClick={this.handleClickRadio.bind(this)}
                checked={
                  this.state.solucao === "substituição do cabo porta poe"
                }
              />
              <label className="form-check-label" htmlFor="solucao2">
                Substituição do cabo porta POE
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="solucao"
                id="solucao3"
                value="substituição da fonte poe"
                onClick={this.handleClickRadio.bind(this)}
                checked={this.state.solucao === "substituição da fonte poe"}
              />
              <label className="form-check-label" htmlFor="solucao3">
                Substituição da fonte POE
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="solucao"
                id="solucao4"
                value="substituiçao do radio"
                onClick={this.handleClickRadio.bind(this)}
                checked={this.state.solucao === "substituiçao do radio"}
              />
              <label className="form-check-label" htmlFor="solucao4">
                Substituiçao do Radio
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="solucao"
                id="solucao5"
                value="substituiçao antena"
                onClick={this.handleClickRadio.bind(this)}
                checked={this.state.solucao === "substituiçao antena"}
              />
              <label className="form-check-label" htmlFor="solucao5">
                Substituiçao Antena
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="solucao"
                id="solucao6"
                value="substituição de estabilizador/nobreak"
                onClick={this.handleClickRadio.bind(this)}
                checked={
                  this.state.solucao === "substituição de estabilizador/nobreak"
                }
              />
              <label className="form-check-label" htmlFor="solucao6">
                Substituição de Estabilizador/Nobreak
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="solucao"
                id="solucao7"
                value="substituição da fonte conversora ac/dc"
                onClick={this.handleClickRadio.bind(this)}
                checked={
                  this.state.solucao ===
                  "substituição da fonte conversora ac/dc"
                }
              />
              <label className="form-check-label" htmlFor="solucao7">
                Substituição da fonte conversora AC/DC
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="solucao"
                id="solucao8"
                value="outro"
                onClick={this.handleClickRadio.bind(this)}
                checked={this.state.solucao === "outro"}
              />
              <label className="form-check-label" htmlFor="solucao8">
                {!this.state.solucaoOutro && this.state.solucao === "outro" ? (
                  <span className="text-danger"> Outro * </span>
                ) : (
                  <React.Fragment>Outro</React.Fragment>
                )}
              </label>
            </div>
            {this.state.solucao === "outro" && (
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  id="inputAddress2"
                  name="solucaoOutro"
                  value={this.state.solucaoOutro}
                  onChange={this.handleInputChange.bind(this)}
                />
              </div>
            )}
          </div>
          <div className="form-group">
            <label>
              {!this.state.imgEquipamentoAtuado.length > 0 ? (
                <span className="text-danger">
                  Foto local/equipamento atuado *
                </span>
              ) : (
                <React.Fragment>Foto local/equipamento atuado</React.Fragment>
              )}
            </label>
            <div className="form-group">
              <ReactFileReader
                handleFiles={this.handleFilesEquipamentoAtuado}
                base64={true}
                multipleFiles={true}
                ref="fotosNecessaria"
                name="fotosNecessaria"
              >
                <button className="btn btn-primary marginRight4">Foto</button>
              </ReactFileReader>
            </div>
            <div className="form-group containerImg">
              {this.state.imgEquipamentoAtuado &&
                this.state.imgEquipamentoAtuado.map((img, i) =>
                  img.foto ? (
                    <div key={i}>
                      <ImgCard
                        description={img.descricao}
                        src={url + "/upload/" + img.foto}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgEquipamentoAtuado", true)
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgEquipamentoAtuadoText"
                        idName={i}
                      />
                    </div>
                  ) : (
                    <div key={i}>
                      <ImgCard
                        src={img}
                        clickDeleteImg={() =>
                          this.deleteImg(i, "imgEquipamentoAtuado")
                        }
                        changeDescricao={e => this.handleInputChangeText(e)}
                        fieldName="imgEquipamentoAtuadoText"
                        idName={i}
                      />
                    </div>
                  )
                )}
            </div>
          </div>
        </React.Fragment>
      );
    }
  }

  render() {
    return (
      <React.Fragment>
        <NavBar wayLast={`/task-descriptions/${this.props.match.params.id}`} />
        <div className="container-fluid container_body">
          <div className="containerCard">
            {this.state.status === "concluido" && (
              <React.Fragment>
                <div>
                  <div className="d-flex justify-content-center">
                    <div className="p-2 bd-highlight align-self-center">
                      <i
                        className="fas fa-check-circle fa-2x"
                        style={{ color: "green" }}
                      />
                    </div>
                    <div className="p-2 bd-highlight align-self-center">
                      <b> Rat Concluída</b>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            )}
            <div className="card marginTop6">
              <h5 className="card-header">Informaçoes do Cliente</h5>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="id">ID Viabilidade</label>
                  <input
                    type="text"
                    className="form-control"
                    id="id"
                    defaultValue={this.state.idViabilidade}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="empresa">Empresa</label>
                  <input
                    type="text"
                    className="form-control"
                    id="empresa"
                    defaultValue={this.state.empresa}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="endereco">Endereço</label>
                  <input
                    type="text"
                    className="form-control"
                    id="endereco"
                    defaultValue={this.state.endereco}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleFormControlSelect1">Número</label>
                  <input
                    type="text"
                    className="form-control"
                    id="inputAddress2"
                    defaultValue={this.state.numero}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="complemento">Complemento</label>
                  <input
                    type="text"
                    className="form-control"
                    id="complemento"
                    defaultValue={this.state.complemento}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="bairro">Bairro</label>
                  <input
                    type="text"
                    className="form-control"
                    id="bairro"
                    defaultValue={this.state.bairro}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="telefone">Telefone</label>
                  <input
                    type="text"
                    className="form-control"
                    id="telefone"
                    defaultValue={this.state.telefone}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="velocidade">Velocidade</label>
                  <input
                    type="text"
                    className="form-control"
                    id="velocidade"
                    //defaultValue={`${this.state.velocidade} Mbps`}
                    value={` ${this.state.velocidade} ${this.state.formatVelocidade}`}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">
                    {!this.state.email ? (
                      <span className="text-danger"> E-mail * </span>
                    ) : (
                      <React.Fragment>E-mail</React.Fragment>
                    )}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="email"
                    name="email"
                    onChange={this.handleInputChange.bind(this)}
                    defaultValue={this.state.email}
                  />
                </div>
              </div>
            </div>
            <div className="card marginTop6">
              <h5 className="card-header">Data</h5>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="dataChegada">Data da Chegada</label>
                  <br />
                  <SingleDatePicker
                    date={this.state.date} // momentPropTypes.momentObj or null
                    onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                    focused={this.state.focused} // PropTypes.bool
                    onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                    id="your_unique_id" // PropTypes.string.isRequired,
                    displayFormat="DD/MM/YYYY"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleFormControlSelect1">
                    {!this.state.hora_chegada ? (
                      <span className="text-danger">
                        {" "}
                        Horário da Chegada *{" "}
                      </span>
                    ) : (
                      <React.Fragment> Horário da Chegada </React.Fragment>
                    )}
                  </label>
                  <MaskedInput
                    mask={[/[0-2]/, /\d/, ":", /[0-5]/, /\d/]}
                    className="form-control"
                    placeholder="digite o horário"
                    guide={false}
                    id="hora_chegada"
                    onBlur={() => {}}
                    //onChange={() => {}}
                    value={this.state.hora_chegada}
                    onChange={this.handleInputChangeHora.bind(this)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleFormControlSelect1">
                    {!this.state.hora_saida ? (
                      <span className="text-danger"> Horário de Saída * </span>
                    ) : (
                      <React.Fragment>Horário de Saída</React.Fragment>
                    )}
                  </label>
                  <MaskedInput
                    mask={[/[0-2]/, /\d/, ":", /[0-5]/, /\d/]}
                    className="form-control"
                    placeholder="digite o horário"
                    guide={false}
                    id="hora_saida"
                    onBlur={() => {}}
                    //onChange={() => {}}
                    value={this.state.hora_saida}
                    onChange={this.handleInputChangeHora.bind(this)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleFormControlSelect1">
                    {!this.state.hora_liberacao ? (
                      <span className="text-danger">
                        {" "}
                        Horário de Liberação *{" "}
                      </span>
                    ) : (
                      <React.Fragment>Horário de Liberação</React.Fragment>
                    )}
                  </label>
                  <MaskedInput
                    mask={[/[0-2]/, /\d/, ":", /[0-5]/, /\d/]}
                    className="form-control"
                    placeholder="digite o horário"
                    guide={false}
                    id="hora_liberacao"
                    onBlur={() => {}}
                    value={this.state.hora_liberacao}
                    onChange={this.handleInputChangeHora.bind(this)}
                  />
                </div>
              </div>
            </div>
            <div className="card marginTop6">
              <h5 className="card-header">Descrição Serviço</h5>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="descricaoDetalhada">
                    Descrição (auto preenchida)
                  </label>
                  <textarea
                    className="form-control"
                    id="descricaoDetalhada"
                    rows="12"
                    name="descricao"
                    onChange={this.handleInputChange.bind(this)}
                    value={this.state.descricao}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label>Tipo de Serviço</label>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="tipo_servico"
                      id="tipo_servico1"
                      value="vistoria"
                      checked={this.state.tipo_servico === "vistoria" || ""}
                      //onChange={this.handleClickRadio.bind(this)}
                      disabled
                    />
                    <label className="form-check-label" htmlFor="tipo_servico1">
                      Vistoria
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      disabled
                      className="form-check-input"
                      type="radio"
                      name="tipo_servico"
                      id="tipo_servico2"
                      value="instalacao"
                      onChange={this.handleClickRadio.bind(this)}
                      checked={this.state.tipo_servico === "instalacao"}
                    />
                    <label className="form-check-label" htmlFor="tipo_servico2">
                      Instalação
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      disabled
                      className="form-check-input"
                      type="radio"
                      name="tipo_servico"
                      id="tipo_servico3"
                      value="retirada"
                      onChange={this.handleClickRadio.bind(this)}
                      checked={this.state.tipo_servico === "retirada"}
                    />
                    <label className="form-check-label" htmlFor="tipo_servico3">
                      Retirada
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      disabled
                      className="form-check-input"
                      type="radio"
                      name="tipo_servico"
                      id="tipo_servico4"
                      value="manutencao_preventiva"
                      checked={
                        this.state.tipo_servico === "manutencao_preventiva"
                      }
                      onChange={this.handleClickRadio.bind(this)}
                    />
                    <label className="form-check-label" htmlFor="tipo_servico4">
                      Manutenção Preventiva
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      disabled
                      className="form-check-input"
                      type="radio"
                      name="tipo_servico"
                      id="tiposervico5"
                      value="manutencao_corretiva"
                      checked={
                        this.state.tipo_servico === "manutencao_corretiva"
                      }
                      onChange={this.handleClickRadio.bind(this)}
                    />
                    <label className="form-check-label" htmlFor="tiposervico5">
                      Manutenção Corretiva
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      disabled
                      className="form-check-input"
                      type="radio"
                      name="tipo_servico"
                      id="tipo_servico6"
                      value="manutencao_emergencial"
                      checked={
                        this.state.tipo_servico === "manutencao_emergencial"
                      }
                      onChange={this.handleClickRadio.bind(this)}
                    />
                    <label className="form-check-label" htmlFor="tipo_servico6">
                      Manutenção Emergencial
                    </label>
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="descricaoDetalhada">
                    Serviço interrompido ?
                  </label>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="servico_interrompido"
                      id="servico_interrompido1"
                      value="1"
                      checked={this.state.servico_interrompido === "1"}
                      onChange={this.handleClickRadio.bind(this)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="servico_interrompido1"
                    >
                      Sim
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="servico_interrompido"
                      id="servico_interrompido2"
                      value="0"
                      onChange={this.handleClickRadio.bind(this)}
                      checked={this.state.servico_interrompido === "0"}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="servico_interrompido2"
                    >
                      Não
                    </label>
                  </div>
                </div>
                {this.state.servico_interrompido === "1" && (
                  <div className="form-group">
                    <label htmlFor="descricaoDetalhada">
                      {!this.state.motivo_servico_interrompido ? (
                        <span className="text-danger">
                          Motivo do serviço interrompido ? *
                        </span>
                      ) : (
                        <React.Fragment>
                          Motivo do serviço interrompido ?
                        </React.Fragment>
                      )}
                    </label>
                    <textarea
                      className="form-control"
                      id="motivo_servico_interrompido"
                      rows="12"
                      name="motivo_servico_interrompido"
                      onChange={this.handleInputChange.bind(this)}
                      value={this.state.motivo_servico_interrompido}
                    />
                  </div>
                )}
                <div className="form-group">
                  <label>
                    {!this.state.escada ? (
                      <span className="text-danger">
                        Será preciso de escada *
                      </span>
                    ) : (
                      <React.Fragment>Será preciso de escada</React.Fragment>
                    )}
                  </label>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="escada"
                      id="escada1"
                      value="sim"
                      checked={this.state.escada === "sim" || ""}
                      onChange={this.handleClickRadio.bind(this)}
                    />
                    <label className="form-check-label" htmlFor="escada1">
                      Sim
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="escada"
                      id="escada2"
                      value="nao"
                      onChange={this.handleClickRadio.bind(this)}
                      checked={this.state.escada === "nao"}
                    />
                    <label className="form-check-label" htmlFor="escada2">
                      Não
                    </label>
                  </div>
                </div>
                {this.state.escada === "sim" && (
                  <div className="form-group">
                    <label>
                      {!this.state.tipo_escada ? (
                        <span className="text-danger">
                          Quantos metros de escada ? *{" "}
                        </span>
                      ) : (
                        <React.Fragment>
                          Quantos metros de escada ?
                        </React.Fragment>
                      )}
                    </label>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="tipo_escada"
                        id="tipo_escada1"
                        value="1"
                        checked={this.state.tipo_escada === "1" || ""}
                        onChange={this.handleClickRadio.bind(this)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="tipo_escada1"
                      >
                        1 metro
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="tipo_escada"
                        id="tipo_escada2"
                        value="3"
                        checked={this.state.tipo_escada === "3" || ""}
                        onChange={this.handleClickRadio.bind(this)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="tipo_escada2"
                      >
                        3 metros
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="tipo_escada"
                        id="tipo_escada3"
                        value="6"
                        checked={this.state.tipo_escada === "6" || ""}
                        onChange={this.handleClickRadio.bind(this)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="tipo_escada3"
                      >
                        6 metros
                      </label>
                    </div>
                  </div>
                )}
                <div className="form-group">
                  <label htmlFor="observacao">
                    {!this.state.observacao ? (
                      <span className="text-danger"> Observação * </span>
                    ) : (
                      <React.Fragment>Observação</React.Fragment>
                    )}
                  </label>
                  <textarea
                    className="form-control"
                    id="observacao"
                    rows="3"
                    name="observacao"
                    onChange={this.handleInputChange.bind(this)}
                    value={this.state.observacao}
                  />
                </div>
                {this.tipo_servico()}

                <div className="form-group">
                  <label htmlFor="obsAdicionais">
                    <i className="fas fa-exclamation-triangle" />
                    {!this.state.observacao_adicionais ? (
                      <span className="text-danger">
                        Observação Adicionais *
                      </span>
                    ) : (
                      <React.Fragment>Observação Adicionais</React.Fragment>
                    )}
                  </label>
                  <textarea
                    className="form-control"
                    id="obsAdicionais"
                    rows="3"
                    onChange={this.handleInputChange.bind(this)}
                    name="observacao_adicionais"
                    value={this.state.observacao_adicionais}
                  />
                </div>
              </div>
            </div>

            <div className="card marginTop6">
              <h5 className="card-header">Responsável </h5>
              <div className="card-body">
                <div className="form-group">
                  <label>
                    {!this.state.assinatura && !this.state.status_assinatura ? (
                      <span className="text-danger"> Assinatura * </span>
                    ) : (
                      <React.Fragment>Assinatura</React.Fragment>
                    )}
                  </label>

                  {this.state.assinatura ? (
                    <div>
                      <img
                        src={this.state.assinatura}
                        width="100%"
                        height="500px"
                        className="sigCanvas "
                        alt="assinatura"
                      />
                      <input
                        type="button"
                        onClick={this.deletarAssinatura}
                        value="Deletar"
                        className="btn btn-danger marginRight2 mt-2"
                      />
                    </div>
                  ) : (
                    <div>
                      <div
                        style={{
                          display:
                            this.state.showAssinatura !== "Habilitar Assinatura"
                              ? "block"
                              : "none"
                        }}
                      >
                        <SignatureCanvas
                          ref={ref => {
                            this.sigCanvas = ref;
                          }}
                          penColor="black"
                          canvasProps={{
                            //height: 500,
                            className: "sigCanvas border1 size100"
                          }}
                          clearOnResize={true}
                        />
                      </div>
                      <input
                        type="button"
                        onClick={this.clearAssin}
                        value="Limpar"
                        className="btn btn-danger marginRight2 mt-2"
                      />

                      <input
                        type="button"
                        value={this.state.showAssinatura}
                        refs="showAssinatura"
                        className="btn btn-primary marginRight2 mt-2"
                        onClick={() =>
                          this.HabilitarDesabilitarAssin(
                            this.state.showAssinatura
                          )
                        }
                      />
                      <input
                        type="button"
                        onClick={this.semAssinatura}
                        value="Sem Assinatura"
                        className="btn btn-danger marginRight2 mt-2"
                      />
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="responsavel">
                    {!this.state.responsavel ? (
                      <span className="text-danger">
                        Nome do Cliente / Responsável *
                      </span>
                    ) : (
                      <React.Fragment>
                        Nome do Cliente / Responsável
                      </React.Fragment>
                    )}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="responsavel"
                    onChange={this.handleInputChange.bind(this)}
                    name="responsavel"
                    defaultValue={this.state.responsavel}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="tecnico">Nome do Técnico</label>
                  <input
                    type="text"
                    className="form-control"
                    id="tecnico"
                    name="tecnico"
                    //onChange={this.handleInputChange.bind(this)}
                    defaultValue={this.state.tecnico}
                    readOnly
                  />
                </div>
              </div>
            </div>

            {this.state.status === "concluido" && (
              <React.Fragment>
                <div className="d-flex justify-content-center">
                  <div className="p-2 bd-highlight align-self-center">
                    <i
                      className="fas fa-check-circle fa-2x"
                      style={{ color: "green" }}
                    />
                  </div>
                  <div className="p-2 bd-highlight align-self-center">
                    <b> Rat Concluída</b>
                  </div>
                  <div className="card marginTop6">
                    <a
                      className="btn btn-success"
                      href={
                        "https://noc.all.com.br/pdfAtividade/pdfRatClient.php?id=" +
                        this.props.match.params.id
                      }
                      role="button"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Enviar E-mail
                    </a>
                  </div>
                </div>
              </React.Fragment>
            )}

            <div className="card marginTop6">
              <Submit
                load={this.state.load}
                submitClick={this.postForm}
                status={
                  this.state.status === "concluido" ||
                  this.state.status === "andamento"
                    ? false
                    : true
                }
              />
            </div>
            {this.state.status === "andamento" && (
              <React.Fragment>
                <div className="card marginTop6">
                  <button className="btn btn-danger" onClick={this.pauseTask}>
                    Pausar Tarefa
                  </button>
                </div>
              </React.Fragment>
            )}

            {(this.state.status === "pause" ||
              this.state.status === "pendente") && (
              <React.Fragment>
                <div className="card marginTop6">
                  <button className="btn btn-success" onClick={this.startTask}>
                    Inicar Tarefa
                  </button>
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ActivityClient;
